"use client";

import { FC } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { MediaBannerHighlightProps, MediaBannerHighlightType } from "@/types";

import "./MediaBannerHighlight.css";
import MediaBannerHighlightCard from "./MediaBannerHighlightCard";

export interface Props {
  entry: MediaBannerHighlightProps;
}

const MediaBannerHighlight: FC<Props> = ({ entry }) => {
  if (entry?.variant === MediaBannerHighlightType.BOXED_CAROUSEL) {
    return (
      <div className="md:mt-[-80px] md:mb-[-56px] relative">
        <Swiper
          slidesPerView={1}
          spaceBetween={22}
          pagination={{ type: "bullets", clickable: true, el: ".media-banner-highlight-pagination" }}
          autoHeight={false}
          watchSlidesProgress={true}
          modules={[Pagination]}
        >
          {entry.content.map((slide, i) => (
            <SwiperSlide className="" key={`media-banner-highlight-${i}`}>
              <MediaBannerHighlightCard boxAlignment={entry.boxAlignment} content={slide} type={entry.variant} />
            </SwiperSlide>
          ))}
          <div className="media-banner-highlight-pagination text-center md:absolute  md:!bottom-[80px]  w-full z-20 mb-m md:mb-0"></div>
        </Swiper>
      </div>
    );
  }

  return (
    <MediaBannerHighlightCard
      boxAlignment={entry.boxAlignment}
      content={entry.content[0]}
      type={entry.variant}
      animation={entry.animation}
      parallaxAnimation={entry.parallaxAnimation}
      wrappedText={entry.wrappedText}
    />
  );
};

export default MediaBannerHighlight;
